module.exports = __webpack_public_path__ + "img/logo.978a7dfc.png";